/* ==========================================================================
   KastKing clone theme — global JS
   ========================================================================== */
(function () {
  'use strict';

  /* ----------------------------------------------------- slider engine
     Markup contract:
       [data-kk-slider]
         .kk-slider > .kk-slider__track > items
         [data-kk-prev] / [data-kk-next]
  */
  function initSlider(root) {
    if (root.dataset.kkSliderReady === 'true') return;
    root.dataset.kkSliderReady = 'true';

    var viewport = root.querySelector('.kk-slider');
    var track = root.querySelector('.kk-slider__track');
    if (!viewport || !track) return;

    var prev = root.querySelector('[data-kk-prev]');
    var next = root.querySelector('[data-kk-next]');
    var pos = 0;

    function step() {
      var first = track.children[0];
      if (!first) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function maxOffset() {
      return Math.max(0, track.scrollWidth - viewport.offsetWidth);
    }

    function apply() {
      var max = maxOffset();
      if (pos > 0) pos = 0;
      if (Math.abs(pos) > max) pos = -max;
      track.style.transform = 'translateX(' + pos + 'px)';
      if (prev) prev.disabled = pos >= 0;
      if (next) next.disabled = Math.abs(pos) >= max - 1;
    }

    function move(dir) {
      // Mobile falls back to native scroll-snap.
      if (window.matchMedia('(max-width: 767px)').matches) {
        viewport.scrollBy({ left: dir * step(), behavior: 'smooth' });
        return;
      }
      pos -= dir * step();
      apply();
    }

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });

    window.addEventListener('resize', debounce(function () {
      pos = 0;
      apply();
    }, 150));

    apply();
    root.kkSliderReset = function () { pos = 0; apply(); };
  }

  /* ----------------------------------------------------- tabs
     [data-kk-tabs] with [data-kk-tab="key"] buttons and
     [data-kk-panel="key"] panels.
  */
  function initTabs(root) {
    if (root.dataset.kkTabsReady === 'true') return;
    root.dataset.kkTabsReady = 'true';

    // Only claim tabs belonging to THIS container. Without this a tab set
    // nested inside another one would be driven by both.
    function own(selector) {
      return Array.prototype.filter.call(root.querySelectorAll(selector), function (el) {
        return el.closest('[data-kk-tabs]') === root;
      });
    }

    var tabs = own('[data-kk-tab]');
    var panels = own('[data-kk-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-kk-tab');

        tabs.forEach(function (t) {
          t.classList.toggle('active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var on = panel.getAttribute('data-kk-panel') === key;
          panel.classList.toggle('active', on);
          panel.hidden = !on;
          if (on) {
            var slider = panel.querySelector('[data-kk-slider]');
            if (slider && slider.kkSliderReset) slider.kkSliderReset();
          }
        });
      });
    });
  }

  /* ----------------------------------------------------- accordion */
  function initAccordion(root) {
    if (root.dataset.kkAccordionReady === 'true') return;
    root.dataset.kkAccordionReady = 'true';

    function own(selector) {
      return Array.prototype.filter.call(root.querySelectorAll(selector), function (el) {
        return el.closest('[data-kk-accordion]') === root;
      });
    }

    var items = own('[data-kk-accordion-item]');
    var exclusive = root.getAttribute('data-kk-accordion-exclusive') === 'true';

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var toggle = item.querySelector('[data-kk-accordion-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    own('[data-kk-accordion-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = toggle.closest('[data-kk-accordion-item]');
        if (!item) return;

        var open = !item.classList.contains('is-open');

        if (exclusive && open) {
          items.forEach(function (other) {
            if (other !== item) setOpen(other, false);
          });
        }

        setOpen(item, open);
        syncAll();
      });
    });

    // Optional "collapse/expand everything" control
    var allBtn = root.parentNode ? root.parentNode.querySelector('[data-kk-accordion-all]') : null;

    function syncAll() {
      if (!allBtn) return;
      var anyOpen = items.some(function (i) { return i.classList.contains('is-open'); });
      allBtn.classList.toggle('is-open', anyOpen);
      allBtn.setAttribute('aria-expanded', anyOpen ? 'true' : 'false');
    }

    if (allBtn) {
      allBtn.addEventListener('click', function () {
        var anyOpen = items.some(function (i) { return i.classList.contains('is-open'); });
        items.forEach(function (item, i) {
          // Expanding an exclusive accordion should still leave only one open
          setOpen(item, anyOpen ? false : (exclusive ? i === 0 : true));
        });
        syncAll();
      });
      syncAll();
    }
  }

  /* ----------------------------------------------------- video modal */
  var modal = null;

  function openVideo(html) {
    modal = modal || document.getElementById('kk-video-modal');
    if (!modal) return;
    modal.querySelector('.kk-video-modal__body').innerHTML = html;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeVideo() {
    if (!modal) return;
    modal.querySelector('.kk-video-modal__body').innerHTML = '';
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function initVideoTriggers(scope) {
    scope.querySelectorAll('[data-kk-video]').forEach(function (el) {
      if (el.dataset.kkVideoReady === 'true') return;
      el.dataset.kkVideoReady = 'true';
      el.addEventListener('click', function (event) {
        var url = el.getAttribute('data-kk-video');
        if (!url) return;
        event.preventDefault();

        var id = null;
        var yt = url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([A-Za-z0-9_-]{6,})/);
        if (yt) id = yt[1];

        if (id) {
          openVideo(
            '<iframe src="https://www.youtube.com/embed/' + id +
            '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'
          );
        } else {
          openVideo('<video src="' + url + '" controls autoplay playsinline></video>');
        }
      });
    });
  }

  /* ----------------------------------------------------- quantity */
  function initQuantity(scope) {
    scope.querySelectorAll('[data-quantity-wrapper]').forEach(function (wrap) {
      if (wrap.dataset.kkQtyReady === 'true') return;
      wrap.dataset.kkQtyReady = 'true';

      var input = wrap.querySelector('input[name="quantity"]');
      if (!input) return;

      wrap.querySelectorAll('[data-quantity-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = btn.getAttribute('data-quantity-change') === 'plus' ? 1 : -1;
          var min = parseInt(input.min || '1', 10);
          var value = (parseInt(input.value, 10) || min) + delta;
          input.value = Math.max(min, value);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ----------------------------------------------------- header */
  function initHeader() {
    var header = document.querySelector('[data-kk-header]');
    if (!header) return;

    // Mobile drawer
    var drawer = header.querySelector('[data-kk-drawer]');
    header.querySelectorAll('[data-kk-drawer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!drawer) return;
        var open = drawer.classList.toggle('is-open');
        document.body.style.overflow = open ? 'hidden' : '';
      });
    });

    // Mobile submenu expand
    header.querySelectorAll('[data-kk-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var parent = btn.closest('[data-kk-submenu-parent]');
        if (parent) parent.classList.toggle('is-open');
      });
    });

    // Search
    var searchToggle = header.querySelector('[data-kk-search-toggle]');
    var search = header.querySelector('[data-kk-search]');
    if (searchToggle && search) {
      searchToggle.addEventListener('click', function () {
        search.classList.toggle('is-open');
        var input = search.querySelector('input[type="search"]');
        if (input && search.classList.contains('is-open')) input.focus();
      });
    }

    // Shrink on scroll
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      header.classList.toggle('is-scrolled', y > 40);
      last = y;
    }, { passive: true });
  }

  /* ----------------------------------------------------- cart count */
  function refreshCartCount() {
    fetch(window.routes.cart_url + '.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }
  window.kkRefreshCartCount = refreshCartCount;

  /* ----------------------------------------------------- utils */
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  window.kkDebounce = debounce;

  /* ----------------------------------------------------- boot */
  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-kk-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-kk-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-kk-accordion]').forEach(initAccordion);
    initVideoTriggers(scope);
    initQuantity(scope);
  }
  window.kkBoot = boot;

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
    initHeader();

    document.querySelectorAll('[data-video-close]').forEach(function (el) {
      el.addEventListener('click', closeVideo);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeVideo();
    });
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
    initHeader();
  });
})();
